module.exports = __webpack_public_path__ + "img/ebook_400.81807404.png";